import SetPrefixHtml from './templates/branches.set-prefix.html';

export function BranchSettingsCtrl (
  $scope,
  $state,
  $translate,
  $uibModal,
  branchesApi,
  confirm,
  franchiseLink,
  messages,
  messengerApi,
  sessionObjAPI,
  settings,
  workshopAPI
) {

  $scope.settings      = settings;
  $scope.company       = sessionObjAPI.company();
  $scope.franchiseLink = franchiseLink;
  $scope.loaded        = true;

  $scope.email = function () {
    messengerApi.email({
      name           : 'Branch Linking Code',
      subject        : 'Workshop Software Branch Linking Code',
      email_address  : '',
      body           : 'Your Workshop Software Branch Linking Code: ' + $scope.company.branch_linking_code,
      attachment_type: 4
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    });
  };

  $scope.grantBranchAccess = function () {
    workshopAPI.get('/company/grant_branch_access', $scope.company.branch_linking_code)
    .then(() => {
      messages.show('Branch Access Granted', 'success');

      return sessionObjAPI.refresh();
    }).then(() => {
      if (
        ( $scope.company.last_xero_sync_down !== null ||
          $scope.company.last_myob_sync_down !== null ||
          $scope.company.last_qbo_sync_down  !== null
        )
        && $scope.company.shares_accounting
      ) {
        $scope.openSetBranchPrefixModal()
        .then(result => {
          workshopAPI.patch('/company_accounting_settings', {
            company_id  : $scope.company.id,
            store_prefix: result
          })
          .then(() => {
            $scope.openBranchLinkToolConfirm($translate.instant('JS_SPACE.BRANCH.BRANCH_LINK_TOOL_CONFIRM'))
            .then(() => {
              $state.go('app.branches.contacts');
            })
            .catch(() => {
              $state.reload();
            });
          });
        });
      }
      else {
        $state.reload();
      }
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.openSetBranchPrefixModal = function () {
    return $uibModal.open({
      templateUrl: SetPrefixHtml,
      controller : [ '$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        $scope.branchPrefix = '';

        $scope.confirm = function () {
          if ($scope.branchPrefix.length <= 3) {
            $uibModalInstance.close($scope.branchPrefix);
          }
        };
      }],
    });
  };

  $scope.openBranchLinkToolConfirm = function (message, type, options = {}) {
    options = angular.extend({
      cancelText : 'GENERAL_SPACE.BUTTON.BRANCH_SETTINGS_NO',
      confirmText: 'GENERAL_SPACE.BUTTON.BRANCH_SETTINGS_YES',
      size       : 'lg'
    }, options);

    return confirm.generic(message, type, options);
  };

  $scope.revokeBranchAccess = function () {
    workshopAPI.get('/company/revoke_branch_access')
    .then(() => {
      messages.show('Branch Access Revoked', 'success');

      return sessionObjAPI.refresh();
    }).then(() => {
      $state.reload();
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.saveSettings = function () {
    workshopAPI.patch('/company_accounting_settings', $scope.settings)
    .then(() => {
      messages.show('Settings Saved', 'success');
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.saveFranchiseLink = function () {
    branchesApi.saveFranchiseLink($scope.franchiseLink)
    .then(() => {
      messages.show('Store Name Saved', 'success');

      $state.reload();
    })
    .catch(error => {
      messages.error(error);
    });
  };
}
